export default __webpack_public_path__ + "static/media/checked-mark.a11ff618.svg";